import { Grid } from "@material-ui/core";

import FormField from "../FormField";

const CustomerProfileForm = ({ customer, setCustomer, fieldsWithError, isCorporation }) => {

    const handleChange = (field, value) =>
        setCustomer({ [field]: value });

    const handleChangeAcquisitionInfo = (fieldName, value) => {
        const currentInfo = { ...customer.acquisition } || {};
        currentInfo[fieldName] = value;
        handleChange('acquisition', currentInfo);
    }

    const handleChangeCompanyInfo = (fieldName, value) => {
        const currentInfo = { ...customer.company } || {};
        currentInfo[fieldName] = value;
        handleChange('company', currentInfo);
    }

    const getCompanyName = () => (
        <FormField
            field='Razão Social' name='companyName'
            placeholder='Digite a Razão Social' required
            currentValue={customer.company?.companyName}
            onChange={handleChangeCompanyInfo}
            onError={fieldsWithError.includes('companyName')}
            titleSize={14} titleColor='grey'
        />
    )

    return (
        <Grid item container direction="column" spacing={5}>

            {isCorporation && getCompanyName()}

            <FormField
                field='OAB' name='oab' placeholder='Digite sua OAB'
                currentValue={customer.oab} onChange={handleChange}
                onError={fieldsWithError.includes('oab')} required
                titleSize={14} titleColor='grey'
            />

            <FormField
                field='Como nos conheceu?' name='channel' type='select'
                options={[
                    { name: 'Linkedin', value: 'Linkedin' },
                    { name: 'Facebook', value: 'Facebook' },
                    { name: 'Instagram', value: 'Instagram' },
                    { name: 'TikTok', value: 'TikTok' },
                    { name: 'Youtube', value: 'Youtube' },
                    { name: 'Google', value: 'Google' },
                    { name: 'Email', value: 'Email' },
                    { name: 'Indicação', value: 'Indicação' },
                    { name: 'Outros', value: 'Outros' }
                ]}
                currentValue={customer.acquisition?.channel}
                onChange={handleChangeAcquisitionInfo} required
                onError={fieldsWithError.includes('channel')}
                titleSize={14} titleColor='grey'
            />

            {customer.acquisition?.channel == 'Outros' &&
                <FormField
                    field='Descreva por onde nos conheceu' name='description'
                    currentValue={customer.acquisition?.description}
                    onChange={handleChangeAcquisitionInfo} required
                    onError={fieldsWithError.includes('description')}
                    titleSize={14} titleColor='grey'
                />
            }
        </Grid>
    )
}

export default CustomerProfileForm;
